var utils = require('../../utils')
import AppHeader from '../AppHeader'
export default {
  name: 'reset-password',
  data: function () {
    return {
      canValidate: true,
      password: null,
      password_retyped: null,
      isSuccess: false,
      updateSuccess: null,
      updateError: null,
      message: null,
      showMessage: false
    }
  },
  created: function () {
    this.$store.dispatch('CLEAR_AUTH_STATUS')
  },
  computed: {
    error () {
      if (this.$store.getters.authStatus === 'error') {
        this.updateError = this.$store.getters.authError || this.$store.getters.apiError
      } else {
        this.updateError = null
      }
      return this.updateError
    },
    success() {
      if (this.$store.getters.authStatus === 'success') {
        this.updateSuccess = this.$t('Update Successful')
      } else {
        this.updateSuccess = null
      }
      return this.updateSuccess
    },
    isResetPasswordSuccess () {
      return (this.$store.getters.authStatus === 'success')
    },
    validation: function() {
      var pass = /^\w{4,10}$/
      var v = {
        password_rule: (pass.test(this.password) || !this.password),
        password_retyped: this.password == this.password_retyped,

        not_input: (pass.test(this.password) || !this.password) &&
                   this.password == this.password_retyped &&
                   !!this.password
      }
      if (!this.canValidate) {
        Object.keys(v).forEach(key => { v[key] = true; });
      }
      return v
    },
    isValid () {
      var validation = this.validation
      return Object.keys(validation).every(function (key) {
        return validation[key]
      })
    }
  },
  components: {
    AppHeader
  },
  methods: {
    changePassword: function() {
      this.updateSuccess = null
      this.updateError = null
      this.canValidate = true
      if (this.isValid) {
        var formData = new FormData();
        formData.append('auth_user[password]', this.password);
        formData.append('auth_user[password_confirmation]', this.password_retyped);
        this.$store.dispatch('CHANGE_PASSWORD', {data: formData})
      } else {
        console.log("need edit")
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/menu-reset-password.js